import { SignIn as SharedSignIn } from "@mattfinkel/common-web";
import { auth, googleProvider } from "../firebase";

// Binding shim. The error mapping -- every branch of which exists because this
// button failed silently on 2026-08-08 -- lives in @mattfinkel/common-web
// alongside `describeSignInError`.
export { describeSignInError } from "@mattfinkel/common-web";

export function SignIn() {
  return <SharedSignIn auth={auth} provider={googleProvider} />;
}
